import cancellable from 'cancellable';
import $ from 'jquery';
import {isString} from 'lodash';

//returns a cancellable promise wrapper for jquery ajax
export default function fetch(...args) {
  return cancellable(
    (cancellation, cancelled) =>
      new Promise((resolve, reject) => {
        const xhr = (isString(args[0]) ? $.get(...args) : $.ajax(...args))
          .done(resolve)
          .fail((...args) => {
            if (!cancelled()) {
              if (args[0].status >= 200 && args[0].status < 300) {
                resolve(args[0].responseText);
              } else {
                reject(...args);
              }
            }
          });

        if (!isString(args[0]) && args[0].controller) {
          args[0].controller.signal.addEventListener('abort', () => {
            xhr.abort();
          });
        }

        cancellation.catch(() => {
          xhr.abort();
        });
      })
  );
}
